import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiError, login } from '../lib/api';
import { copy, translateApiError } from '../lib/copy';
import { useAuth } from '../context/AuthContext';

export function LoginPage() {
  const navigate = useNavigate();
  const { setOperator } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const data = await login(email.trim(), password);
      setOperator(data.operator);
      navigate('/', { replace: true });
    } catch (err) {
      let message: string = copy.login.defaultError;
      if (err instanceof ApiError) {
        message = translateApiError(err.message);
      } else if (err instanceof Error && err.message) {
        message = translateApiError(err.message);
      }
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ops-bg p-4">
      <div className="w-full max-w-md ops-card">
        <div className="mb-6 text-center">
          <h1 className="text-xl font-semibold">{copy.login.title}</h1>
          <p className="mt-1 text-sm text-ops-muted">{copy.login.subtitle}</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="mb-1 block text-xs font-medium text-ops-muted">
              {copy.login.email}
            </label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              required
              className="ops-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="password" className="mb-1 block text-xs font-medium text-ops-muted">
              {copy.login.password}
            </label>
            <div className="flex gap-2">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                required
                minLength={8}
                className="ops-input flex-1"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="ops-btn-secondary shrink-0 px-3"
                onClick={() => setShowPassword((v) => !v)}
              >
                {showPassword ? copy.common.hide : copy.common.show}
              </button>
            </div>
          </div>
          {error ? (
            <p className="rounded-pill border border-ops-danger/20 bg-ops-danger-soft px-3 py-2 text-sm text-ops-danger">
              {error}
            </p>
          ) : null}
          <button type="submit" disabled={loading} className="ops-btn-primary w-full">
            {loading ? copy.login.submitting : copy.login.submit}
          </button>
        </form>
      </div>
    </div>
  );
}
